import { useEffect, useState } from 'react'

// Singleton state so all consumers share the same countdown
let globalTimeLeft = 10 * 60 + 53
let listeners: Set<(t: number) => void> = new Set()
let intervalId: ReturnType<typeof setInterval> | null = null

function startGlobalTimer() {
  if (intervalId) return
  intervalId = setInterval(() => {
    if (globalTimeLeft <= 1) {
      globalTimeLeft = 0
      if (intervalId) {
        clearInterval(intervalId)
        intervalId = null
      }
    } else {
      globalTimeLeft -= 1
    }
    listeners.forEach((fn) => fn(globalTimeLeft))
  }, 1000)
}

export function useCountdown() {
  const [timeLeft, setTimeLeft] = useState(globalTimeLeft)

  useEffect(() => {
    listeners.add(setTimeLeft)
    startGlobalTimer()
    return () => {
      listeners.delete(setTimeLeft)
      if (listeners.size === 0 && intervalId) {
        clearInterval(intervalId)
        intervalId = null
      }
    }
  }, [])

  return {
    timeLeft,
    minutes: Math.floor(timeLeft / 60),
    seconds: timeLeft % 60,
    isExpired: timeLeft <= 0,
    isUrgent: timeLeft <= 180,
  }
}
